module.exports = {
    validateEmail: (mail) => {
        if (mail === null) return true;
        return /^\w+([\.-]?\ w+)*@\w+([\.-]?\ w+)*(\.\w{2,3})+$/.test(mail);
    },

    isNullOrEmpty: (string) => {
        return string === null || string === "";
    },

    deflate: (string) => {
        return string.replace(/\s+/g, '-');
    },

    scrollToTop: (speed = 500, topOffset = 0) => $('html, body').animate({scrollTop : topOffset}, speed)
};


// WEBPACK FOOTER //
// ./src/mixins.js